// Constants and Utils
import { LocalStorageKeys } from "../constants/GeneralConstants";
import { getItem } from "./localstorage";

/**
 * Function to check whether user is Buyer or not
 * @returns true/false
 */
export function checkIsBuyerUser() {
  const user = JSON.parse(getItem(LocalStorageKeys.USER)) || {};
  const { buyerId } = user || {};

  // checking
  const isBuyerUser = buyerId ? true : false;

  return isBuyerUser;
}

/**
 * Function to check whether Buyer user have Edit Campaign Access or not
 * @returns true/false
 */
export function checkCanBuyerUserEditCampaign() {
  // first check isBuyerUser
  const isBuyerUser = checkIsBuyerUser();

  // id user is not buyer user then directly return false
  if (!isBuyerUser) {
    return false;
  }

  // check for edit access
  const user = JSON.parse(getItem(LocalStorageKeys.USER)) || {};
  const { isCampEditUser = false } = user || {};

  return Boolean(isCampEditUser);
}
